'use client';

import ChatWidget from './ChatWidget';
import BrevoChatScript from './BrevoChatScript';

export default function ChatProvider() {
  const provider = process.env.NEXT_PUBLIC_CHAT_PROVIDER || 'db';

  if (provider === 'brevo') {
    return <BrevoChatScript />;
  }

  return <ChatWidget />;
}
